<!--合作方相关资料-->
<template>
  <div>
    <div id="formHtml" style="padding:30px 30px;">
        <div style="background:#1c1c1c;">
      <table cellspacing="1" cellpadding="0" width="100%" >
        <tr>
          <td  colspan="6" style="height:80px;"><span style="font-size:20px;">合作方相关资料</span></td>
        </tr>
        <tr>
          <td>序号</td>
          <td>单位名称</td>
          <td>法人代表</td>
          <td>联系人</td>
          <td>手机号码</td>
          <td>经营地址</td>
        </tr>
        <tbody v-for="(obj, index) in form.list">
        <tr >
          <td  style="width:65px;">{{index+1}}</td>
          <td><input v-model="obj.ccEntName" type="text" :class="edit(obj.ccEntName)"/></td>
          <td><input v-model="obj.ccPersonName" type="text" :class="edit(obj.ccPersonName)"/></td>
          <td><input v-model="obj.ccContactName" type="text" :class="edit(obj.ccContactName)"/></td>
          <td><input v-model="obj.phone" type="text" :class="edit(obj.phone)"/></td>
          <td><input v-model="obj.businessAddress" type="text" :class="edit(obj.businessAddress)"/></td>
        </tr>
        <tr v-for="(car, index) in obj.carList">
          <td v-if="index==0" :rowspan="obj.carList.length">车辆信息<el-button v-if="editStatus" size="small" type="success" @click="addRow2(obj)">添加车辆</el-button></td>
          <td colspan="5"><input type="text" v-model="car.carNo" :class="edit(car.carNo)"/></td>
        </tr>
        </tbody>
      </table>
    </div>
    </div>

    <div style="padding:30px 30px;">
      <el-button size="small" type="success" @click="addRow">添加合作方</el-button>
    </div>

    <a id="download" v-show="false"/>
    <div  class="dialog-footer" style="margin-top:10px;text-align: center;">
      <el-button @click="closeDialog()"  size="small">取 消</el-button>
      <el-button  size="small" type="primary" v-if="!prop.preview" @click="create('form')">保存</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as html2canvas from "html2canvas";
import {enterpriseDetail} from "../../../api/admin/sysEnterprise/index";
import {addObj, getObj, putObj} from "../../../api/admin/sysFormPartners/index";
export default {
  name: 'oilRegisterForm',
  props: ["formId", "prop"],
  data() {
    return {
      editStatus:true,
      form:{
          formId:null,
          entName:null,
          list:[{
              formId:null,
              ccEntName:null,
              ccPersonName:null,
              ccContactName:null,
              phone:null,
              businessAddress:null,
              carNos:"",
              carList:[{carNo:""}]
          }]
      },
      types:[
        {value:"灭火器", label:"灭火器"},
        {value:"其他", label:"其他"},
      ]
    }
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters([
      'elements'
    ])
  },
  methods: {
    init: function () {
        if(this.formId){
            getObj(this.formId).then(response=>{
                response.list = response.list.map(x=>{
                    x.carList=x.carNos.split(",").map(y=>{
                        return {"carNo": y};
                    });
                    return x;
                });
                this.form= response;
            })
        }else{
            enterpriseDetail({}).then(response => {
                this.form.entName = response.entName;
            });
        }
    },
    html(callback) {
        html2canvas(document.querySelector("#formHtml"), {scale: 2}).then(canvas => {
            callback && callback(canvas);
        })
    },
    download(fileName){
        this.html((canvas)=>{
            fileName += ".png";
            if (window.navigator.msSaveBlob) {
                var blob = canvas.msToBlob()
                window.navigator.msSaveBlob(blob, fileName)
            } else {
                var url = canvas.toDataURL()     //把canvas转成base64
                // 写一个隐藏的按标签，借助按标签的download属性下载图片
                document.querySelector('#download').href = url;
                document.querySelector('#download').download = fileName;
                document.querySelector('#download').click()
            }
        });
    },
    create() {
        this.editStatus = false;
        this.form.list.map(x=>{
            x.carNos = x.carList.map(y=>y.carNo).join(",");
            return x;
        });
        this.$nextTick(()=>{
            addObj(this.form).then((response) => {
                this.html(canvas=>{
                    this.$emit("on-success", {...response, content: canvas.toDataURL()});
                })
            })
        })
    },
    addRow:function(){
      let obj = Object.assign({}, this.form.list[0]);
      Object.keys(obj).forEach(x=>{
        obj[x] = null;
      })
      obj.carList = [{carNo:""}];
      this.form.list.push(obj);
    },
    addRow2:function(item){
        let obj = {...this.form.list[0].carList[0]}
        Object.keys(obj).forEach(x=>{
            obj[x] = null;
        })
        item.carList.push(obj);
    },
    edit:function(val){
      if(val && String.valueOf(val).length>0 || this.prop.preview){
        return "edit";
      }
      return "";
    },
    closeDialog(){
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
table td {background:#FFF;padding:0px 4px;height:40px;box-sizing:border-box;text-align:center;}
table td .checkbox{width:16px;height:16px;border:solid 1px #000;background:#FFF;position:relative;top:3px;}
table td input{background:url(./img/edit.png) 10px no-repeat;width:100%;height:100%;border:none;text-indent:0px;border:none;font-size:14px;outline:none;padding-left:10px;box-sizing: border-box;}
table td .shortInput{ width:60px;height:100%;border:none;}
table td .longInput{ width:290px;height:100%;border:none;}
.edit{background:transparent;}
</style>